/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/react-in-jsx-scope */
import { Select, SelectItem } from '@nextui-org/react';

interface IOptions {
  label: string;
  value: string | number;
}
interface ICustomSelect {
  options: IOptions[];
  placeholder?: string;
  className?: string;
  selectionMode?: 'single' | 'multiple';
  defaultSelectedKeys?: any;
  selectedKeys?: any;
  onChange?: (value: any) => void;
  onSelectItem?: (item: any) => void;
}
const CustomSelect = (props: ICustomSelect) => {
  const {
    options,
    placeholder,
    defaultSelectedKeys,
    selectionMode,
    selectedKeys,
    onChange,
    className = '',
    onSelectItem,
    ...rest
  } = props;

  return (
    <Select
      classNames={{
        base: 'w-[76px]',
        value: ['font-semibold'],
        trigger: ['bg-white/5 border-1 border-border-secondary data-[hover=true]:bg-white'],
      }}
      defaultSelectedKeys={defaultSelectedKeys}
      selectedKeys={selectedKeys}
      onChange={onChange}
      radius='md'
      size='sm'
      selectionMode={selectionMode}
      className={className}
      placeholder={placeholder}
      {...rest}
    >
      {options.map((item) => (
        <SelectItem key={item.value} onClick={() => onSelectItem?.(item)}>
          {item.label}
        </SelectItem>
      ))}
    </Select>
  );
};

export default CustomSelect;
